<div class="mb-24">
  <div class="title title--big">Редактирование сотрудника</div>
</div>

<app-users-create-edit-widget></app-users-create-edit-widget>
